module.exports = __webpack_public_path__ + "img/1-md.df0c638b.jpg";